import { Card, Typography } from 'antd';
import { User } from 'interfaces/course_certificate';
import { formatCPF } from 'utils/document-formatters';

const { Text } = Typography;

interface StudentInfoCardProps {
  user: User;
  registration: string;
}

export const StudentInfoCard = ({
  user,
  registration
}: StudentInfoCardProps) => {
  return (
    <Card size="small" className="border-0 shadow-none bg-transparent">
      <Text strong className="block">
        {user.full_name_or_name}
      </Text>
      <Text type="secondary" className="block text-sm">
        Email: {user.email || '-'}
      </Text>
      <Text type="secondary" className="block text-sm">
        Matrícula: {registration}
      </Text>
      <Text type="secondary" className="block text-sm">
        CPF: {formatCPF(user.personal_info?.document_info || '-')}
      </Text>
    </Card>
  );
};
